import { render, staticRenderFns } from "./applyInvoice.vue?vue&type=template&id=5bb1d245&scoped=true"
import script from "./applyInvoice.vue?vue&type=script&lang=js"
export * from "./applyInvoice.vue?vue&type=script&lang=js"
import style0 from "./applyInvoice.vue?vue&type=style&index=0&id=5bb1d245&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb1d245",
  null
  
)

export default component.exports